import { dmApi } from "../dmApi";
import { getAuthorizationHeader, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";

export const faqApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getAllFaqs: build.query({
      query: (id) => ({
        url: `/admin/get-all-faqs?categoryId=${id}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['Faq'],
    }),
    createFaq: build.mutation({
      query: (faq) => ({
        url: "/admin/create-faqs",
        method: "POST",
        body: faq,
        headers: getAuthorizationHeader()
      }),
      invalidatesTags: ['Faq'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "", "FAQ created successfully");
      }
    }),
    getFaqById: build.query({
      query: (faqId) => ({
        url: `/admin/get-faqs-by-id?faqId=${faqId}`,
        method: "GET",
        headers: getAuthorizationHeader()
      }),
      providesTags: ['faqId']
    }),
    updateFaq: build.mutation({
      query: ({ faqId, ...body }) => ({
        url: `/admin/update-faqs?faqId=${faqId}`,
        method: "PUT",
        body,
        headers: getAuthorizationHeader()
      }),
      invalidatesTags: ['Faq', 'faqId'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "", "FAQ updated successfully");
      }
    }),
    // Create FAQ Category
    createFaqCategory: build.mutation({
      query: (body) => ({
        url: "/admin/create-faq-categories",
        method: "POST",
        body,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['FaqCategory'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Category created');
      },
    }),

    // Update FAQ Category
    updateFaqCategory: build.mutation({
      query: ({ categoryId, ...body }) => ({
        url: `/admin/update-faq-category?categoryId=${categoryId}`,
        method: "PUT",
        body,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['FaqCategory'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Category updated');
      },
    }),

    // Get all FAQ categories
    getFaqCategories: build.query({
      query: () => ({
        url: "/admin/get-faq-categories",
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['FaqCategory'],
    }),
    getContactApi: build.query({
      query: () => ({
        url: "admin/get-contact-us",
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['contactUsApi'],
    }),
   updateContact: build.mutation({
      query: ({ contactId,body }) => ({
        url: `/admin/update-contact-us?contactId=${contactId}`,
        method: "PUT",
        body:body,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['contactUsApi'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Contact updated');
      },
    }),
    // Get single FAQ category
    getFaqCategoryById: build.query({
      query: (id) => ({
        url: `/admin/get-faq-category-by-id?categoryId=${id}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      })
       
    }),
    toggleFaqActive: build.mutation({
      query: (id) => ({
        url: `/admin/faqs-toggle-active?faqId=${id}`,
        method: 'PATCH',
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags:['Faq']
    }),
  })
});

export const {
  useGetAllFaqsQuery,
  useCreateFaqMutation,
  useGetFaqByIdQuery,
  useUpdateFaqMutation,
  useCreateFaqCategoryMutation,
  useUpdateFaqCategoryMutation,
  useGetFaqCategoriesQuery,
  useGetFaqCategoryByIdQuery,
  useToggleFaqActiveMutation,
  useGetContactApiQuery,
  useUpdateContactMutation
} = faqApi;
